var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPendingSyndicates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.722 19.2781C6.146 18.8611 5.621 18.3801 5.16 17.8401",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.52301 9C4.08401 7.417 5.06801 6.035 6.34901 5",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00001 12C3.00001 13.054 3.19001 14.06 3.52301 15",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.559 4.40709C20.218 5.06609 20.218 6.13509 19.559 6.79409C18.9 7.45309 17.831 7.45309 17.172 6.79409C16.513 6.13509 16.513 5.06609 17.172 4.40709C17.831 3.74809 18.9 3.74809 19.559 4.40709",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.0001C16.971 21.0001 21 16.9711 21 12.0001C21 11.4571 20.944 10.9281 20.852 10.4121",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.053 4.553C15.612 3.573 13.873 3 12 3C11.088 3 10.209 3.138 9.38 3.39",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.995 9.0049C16.649 10.6589 16.649 13.3409 14.995 14.9949C13.341 16.6489 10.659 16.6489 9.005 14.9949C7.351 13.3409 7.351 10.6589 9.005 9.0049C10.659 7.3509 13.341 7.3509 14.995 9.0049",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingSyndicates);
export default __webpack_public_path__ + "static/media/pending-syndicates.01d03a234d826bbffec1aca919c3c182.svg";
export { ForwardRef as ReactComponent };